import { isFinite } from 'lodash';
import { IValidatorFactoryService } from './validator-factory.service';
import { IValidatorFn } from '../../../interfaces/IValidatorFn';
import { shellStringResources } from '../../../Resources/ShellStringResources';
import { INumberMetadata } from '../../metadatas/validator/number-metadata';

export class NumberValidatorFactoryService implements IValidatorFactoryService<INumberMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'number';

    public createValidatorByMetadata(metadata: INumberMetadata): IValidatorFn {
        return this.createValidator(metadata.min, metadata.max, metadata.errorMessage);
    }
    public createValidator(min: number = -Number.MAX_VALUE, max: number = Number.MAX_VALUE, errMsg?: string): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : shellStringResources.Validator_ErrorMessage_Number;
        return (value: number) => {
            return (!value && value !== 0) || (isFinite(+value) && (value >= min) && (value <= max)) ? null : errorMessage;
        };
    }
}
